


import ThreeD from "./ThreeD";
import React, { useEffect, useMemo, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { FaFacebookF, FaInstagram, FaLinkedin, FaWhatsapp } from "react-icons/fa";

import bslogo from "./assets/companylogo.png";
import csimg from "./assets/csimg.jpg";
import dsimg from "./assets/dsimg.jpg";
import feimg from "./assets/feimg.jpg";
import image3 from "./assets/image3.jpg";

const Services = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const particles = useMemo(
    () =>
      Array.from({ length: 30 }, (_, i) => ({
        id: i,
        size: `${6 + (i % 7) * 5}px`,
        left: `${(i * 3.5) % 100}%`,
        delay: `${(i % 8) * 0.85}s`,
        duration: `${10 + (i % 6) * 2.2}s`,
        opacity: 0.08 + (i % 5) * 0.04,
      })),
    []
  );

  useEffect(() => {
    const revealTargets = document.querySelectorAll(
      ".reveal-up, .reveal-left, .reveal-right, .title-glow"
    );

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("visible");
        });
      },
      { threshold: 0.15 }
    );

    revealTargets.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const developmentServices = [
    {
      title: "Mobile Applications",
      description: "Native and cross-platform apps for iOS and Android, tailored to your specific business needs.",
      icon: "📱",
      features: ["Custom UI/UX", "Real-time Sync", "Offline Support", "Push Notifications"]
    },
    {
      title: "Web Applications",
      description: "Responsive, scalable web platforms and SaaS solutions built with modern technologies.",
      icon: "🌐",
      features: ["Dynamic Dashboards", "Admin Panels", "API Integration", "Real-time Updates"]
    },
    {
      title: "E-Commerce Platforms",
      description: "Complete online shopping solutions with payment integration, inventory, and vendor management.",
      icon: "🛒",
      features: ["Shopping Cart", "Payment Gateway", "Inventory", "Order Tracking"]
    },
    {
      title: "Enterprise Solutions",
      description: "Large-scale systems for government, healthcare, real estate, and community management.",
      icon: "🏢",
      features: ["Multi-user Access", "Role-based Security", "Advanced Analytics", "Scalability"]
    },
    {
      title: "Progressive Web Apps",
      description: "Fast, reliable web apps that work offline with native app-like experience.",
      icon: "⚡",
      features: ["Fast Loading", "Offline Mode", "Installable", "App-like Experience"]
    },
    {
      title: "Custom Integrations",
      description: "Seamless integration with third-party services, APIs, and existing systems.",
      icon: "🔗",
      features: ["API Integration", "Data Sync", "Automation", "System Migration"]
    }
  ];

  const developmentProcess = [
    {
      phase: "Requirement Analysis",
      description: "We listen to understand your vision, goals, target audience, and specific requirements. No generic solutions—everything is customized.",
      points: ["Business Goals", "User Research", "Technical Requirements", "Budget & Timeline"]
    },
    {
      phase: "Design & Planning",
      description: "We create detailed wireframes, prototypes, and technical specifications before any development begins.",
      points: ["UI/UX Design", "User Flows", "Architecture Planning", "Technology Selection"]
    },
    {
      phase: "Custom Development",
      description: "Our team builds your solution using best practices, clean code, and scalable architecture tailored to your needs.",
      points: ["Frontend Development", "Backend Development", "Database Design", "API Development"]
    },
    {
      phase: "Testing & QA",
      description: "Rigorous testing across all devices, browsers, and scenarios to ensure quality and reliability.",
      points: ["Unit Testing", "Integration Testing", "Performance Testing", "Security Testing"]
    },
    {
      phase: "Deployment & Launch",
      description: "We deploy your app to production with zero downtime and provide full support during launch.",
      points: ["App Store Setup", "Server Configuration", "Performance Optimization", "Go-live Support"]
    },
    {
      phase: "Support & Maintenance",
      description: "Ongoing support, updates, feature enhancements, and server management for long-term success.",
      points: ["Bug Fixes", "Feature Updates", "Performance Monitoring", "Security Updates"]
    }
  ];

  const serviceCards = [
    {
      title: "Cyber Security",
      text: "Advanced security assessments, vulnerability management, cloud protection, monitoring, and proactive defense systems for modern businesses.",
      image: csimg,
    },
    {
      title: "Web Development",
      text: "Fast, responsive, scalable websites and platforms built for performance, usability, and long-term business growth.",
      image: dsimg,
    },
    {
      title: "Frontend Development",
      text: "Interactive, premium user interfaces crafted with strong usability, accessibility, and smooth digital experiences.",
      image: feimg,
    },
    {
      title: "Programming & JavaScript",
      text: "Robust application logic, dynamic workflows, modern integrations, and scalable code architecture tailored to your goals.",
      image: image3,
    },
  ];

  return (
    <div className="services-page-root">
      <style>{` 

      html,
body {
  cursor: auto !important;
}

input,
textarea {
  cursor: text !important;
  caret-color: #a3e635;
}

button,
a,
select,
.apply-btn,
.hero-btn,
.close {
  cursor: pointer !important;
}

canvas {
  pointer-events: none;
}
        * {
          box-sizing: border-box;
          margin: 0;
          padding: 0;
        }

        :root {
          --bg-1: #0a0e1a;
          --bg-2: #131a2c;
          --bg-3: #131a2c;

          --text-main: #eef2f7;
          --text-soft: #94a3b8;
          --text-muted: #a8b3c4;

          --accent: #a3e635;
          --accent-2: #bef264;
          --accent-deep: #84cc16;

          --line-soft: rgba(163, 230, 53, 0.16);
          --card-bg: rgba(19, 26, 44, 0.96);
          --card-bg-2: rgba(19, 26, 44, 0.9);

          --shadow-orange: 0 16px 40px rgba(163, 230, 53, 0.16);
          --shadow-soft: 0 18px 45px rgba(15, 23, 42, 0.08);
          --shadow-card: 0 14px 35px rgba(15, 23, 42, 0.09);

          --heading-font: "Cinzel", serif;
          --body-font: "Manrope", sans-serif;
        }

        html {
          scroll-behavior: smooth;
        }

        body {
          font-family: var(--body-font);
          color: var(--text-main);
          background: #0a0e1a;
          overflow-x: hidden;
        }

        a {
          text-decoration: none;
          color: inherit;
        }

        .services-page-root {
          position: relative;
          min-height: 100vh;
          overflow: hidden;
          background: transparent;
        }

        .animated-bg {
          position: fixed;
          inset: 0;
          z-index: 0;
          pointer-events: none;
          display: none;
        }

        .gradient-orb {
          position: absolute;
          border-radius: 50%;
          filter: blur(100px);
          opacity: 0.22;
          animation: orbFloat 14s ease-in-out infinite alternate;
        }

        .orb-1 {
          width: 300px;
          height: 300px;
          top: 80px;
          left: -80px;
          background: rgba(163, 230, 53, 0.24);
        }

        .orb-2 {
          width: 360px;
          height: 360px;
          right: -120px;
          top: 180px;
          background: rgba(163, 230, 53, 0.20);
          animation-duration: 18s;
        }

        .orb-3 {
          width: 280px;
          height: 280px;
          left: 35%;
          bottom: 40px;
          background: rgba(163, 230, 53, 0.18);
          animation-duration: 16s;
        }

        .particles-layer {
          position: absolute;
          inset: 0;
          overflow: hidden;
        }

        .particle {
          position: absolute;
          bottom: -60px;
          border-radius: 50%;
          background: radial-gradient(
            circle,
            rgba(163, 230, 53, 0.7),
            rgba(163, 230, 53, 0.18) 62%,
            transparent 75%
          );
          box-shadow: 0 0 18px rgba(163, 230, 53, 0.18);
          animation-name: floatParticle;
          animation-timing-function: linear;
          animation-iteration-count: infinite;
        }

        @keyframes floatParticle {
          0% {
            transform: translateY(0) translateX(0) scale(0.7);
            opacity: 0;
          }

          12% {
            opacity: 0.75;
          }

          50% {
            transform: translateY(-45vh) translateX(22px) scale(1);
          }

          100% {
            transform: translateY(-110vh) translateX(-30px) scale(1.12);
            opacity: 0;
          }
        }

        @keyframes orbFloat {
          0% {
            transform: translate3d(0, 0, 0) scale(1);
          }

          100% {
            transform: translate3d(40px, -30px, 0) scale(1.12);
          }
        }

        @keyframes glowPulse {
          0%, 100% {
            text-shadow: 0 0 12px rgba(163, 230, 53, 0.10);
          }

          50% {
            text-shadow: 0 0 24px rgba(163, 230, 53, 0.26);
          }
        }

        @keyframes shineSweep {
          0% {
            transform: translateX(-120%);
          }

          100% {
            transform: translateX(120%);
          }
        }

        @keyframes fadeUp {
          from {
            opacity: 0;
            transform: translateY(45px);
          }

          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fadeLeft {
          from {
            opacity: 0;
            transform: translateX(-60px);
          }

          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes fadeRight {
          from {
            opacity: 0;
            transform: translateX(60px);
          }

          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        .services-navbar,
        .services-hero-section,
        .services-section,
        .services-grid-wrap,
        .dev-services-section,
        .process-section,
        .tech-section,
        .services-footer {
          position: relative;
          z-index: 1;
        }

        .services-navbar {
          position: sticky;
          top: 0;
          z-index: 1000;
          background: rgba(19, 26, 44, 0.88);
          backdrop-filter: blur(16px);
          border-bottom: 1px solid rgba(163, 230, 53, 0.12);
          box-shadow: 0 8px 28px rgba(15, 23, 42, 0.05);
        }

        .services-nav-container {
          width: min(1220px, 92%);
          margin: 0 auto;
          padding: 16px 0;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .services-nav-logo {
          display: flex;
          align-items: center;
          gap: 14px;
        }

        .services-nav-logo img {
          width: 54px;
          height: 54px;
          object-fit: contain;
          border-radius: 14px;
          filter: drop-shadow(0 8px 18px rgba(163, 230, 53, 0.18));
        }

        .site-title {
          font-family: var(--heading-font);
          font-size: 1.45rem;
          font-weight: 800;
          letter-spacing: 1px;
          color: #eef2f7;
        }

        .back-button {
          width: 42px;
          height: 42px;
          border-radius: 50%;
          border: none;
          background: linear-gradient(135deg, var(--accent-deep), var(--accent-2));
          color: #fff;
          font-size: 18px;
          cursor: pointer;
          transition: transform 0.28s ease, box-shadow 0.28s ease;
          box-shadow: 0 10px 24px rgba(163, 230, 53, 0.22);
        }

        .back-button:hover {
          transform: scale(1.08);
        }

        .services-nav-links {
          display: flex;
          align-items: center;
          gap: 22px;
        }

        .services-nav-links a {
          color: var(--text-soft);
          font-size: 0.96rem;
          font-weight: 700;
          position: relative;
          transition: color 0.28s ease;
        }

        .services-nav-links a:hover,
        .services-nav-links a.active {
          color: var(--accent-deep);
        }

        .services-nav-links a::after {
          content: "";
          position: absolute;
          left: 0;
          bottom: -7px;
          width: 0%;
          height: 2px;
          border-radius: 999px;
          background: linear-gradient(90deg, var(--accent), var(--accent-2));
          box-shadow: 0 0 14px rgba(163, 230, 53, 0.28);
          transition: width 0.3s ease;
        }

        .services-nav-links a:hover::after,
        .services-nav-links a.active::after {
          width: 100%;
        }

        .nav-toggle {
          display: none;
          font-size: 1.8rem;
          color: #eef2f7;
          cursor: pointer;
        }

        .services-hero-section {
          width: min(1220px, 92%);
          margin: 32px auto 0;
        }

        .services-hero {
          position: relative;
          min-height: 540px;
          border-radius: 30px;
          overflow: hidden;
          background:
            linear-gradient(135deg, rgba(0, 0, 0, 0.56), rgba(14, 14, 14, 0.35)),
            url(${dsimg}) center/cover no-repeat;
          box-shadow: var(--shadow-soft);
          border: 1px solid rgba(163, 230, 53, 0.12);
        }

        .hero-overlay {
          position: absolute;
          inset: 0;
          background:
            radial-gradient(circle at 20% 30%, rgba(163, 230, 53, 0.18), transparent 30%),
            linear-gradient(135deg, rgba(0, 0, 0, 0.55), rgba(0, 0, 0, 0.20));
        }

        .services-hero-content {
          position: relative;
          z-index: 2;
          max-width: 700px;
          padding: 90px 60px;
        }

        .hero-heading,
        .section-heading {
          font-family: var(--heading-font);
          line-height: 1.1;
          letter-spacing: 0.8px;
        }

        .hero-heading {
          color: #ffffff;
          font-size: clamp(2.8rem, 5vw, 4.6rem);
          margin-bottom: 22px;
        }

        .section-heading {
          color: #eef2f7;
          font-size: clamp(2rem, 3vw, 3rem);
          margin-bottom: 18px;
        }

        .section-heading::after {
          content: "";
          display: block;
          width: 64px;
          height: 4px;
          background: linear-gradient(90deg, var(--accent), var(--accent-2));
          border-radius: 3px;
          margin-top: 16px;
        }

        .hero-subtext {
          color: #f8fafc;
          line-height: 1.9;
          font-size: 1rem;
          margin-bottom: 24px;
        }

        .section-content p,
        .service-card p,
        .dev-service-card p,
        .process-point p,
        .footer-col p,
        .footer-col li a {
          color: var(--text-soft);
          line-height: 1.9;
          font-size: 1rem;
        }

        .section-mini {
          display: inline-block;
          font-size: 0.78rem;
          font-weight: 800;
          letter-spacing: 3px;
          color: var(--accent-deep);
          margin-bottom: 12px;
        }

        .hero-mini {
          color: var(--accent-2);
        }

        .title-glow {
          animation: glowPulse 4s ease-in-out infinite;
        }

        .hero-btn {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          min-width: 220px;
          padding: 15px 28px;
          border-radius: 999px;
          color: white;
          font-weight: 800;
          letter-spacing: 0.4px;
          background: linear-gradient(135deg, var(--accent-deep), var(--accent-2));
          box-shadow: 0 12px 30px rgba(163, 230, 53, 0.28);
          position: relative;
          overflow: hidden;
          transition: transform 0.28s ease, box-shadow 0.28s ease;
        }

        .hero-btn::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 45%;
          height: 100%;
          background: linear-gradient(
            90deg,
            transparent,
            rgba(163, 230, 53, 0.28),
            transparent
          );
          transform: translateX(-120%);
          animation: shineSweep 3.5s infinite;
        }

        .hero-btn:hover {
          transform: translateY(-3px) scale(1.02);
          box-shadow: 0 18px 38px rgba(163, 230, 53, 0.30);
        }

        .services-section,
        .services-grid-wrap,
        .dev-services-section,
        .process-section,
        .services-footer {
          width: min(1220px, 92%);
          margin: 42px auto 0;
        }

        .intro-shell {
          padding: 36px 34px;
          border-radius: 28px;
          background:
            linear-gradient(180deg, rgba(19, 26, 44, 0.96), rgba(19, 26, 44, 0.88));
          border: 1px solid rgba(163, 230, 53, 0.14);
          box-shadow: var(--shadow-card);
        }

        /* DEVELOPMENT SERVICES SECTION */
        .dev-services-grid {
          margin-top: 30px;
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 24px;
        }

        .dev-service-card {
          background: linear-gradient(180deg, rgba(163, 230, 53, 0.16), rgba(19, 26, 44, 0.92));
          border: 1px solid rgba(163, 230, 53, 0.28);
          border-radius: 26px;
          padding: 32px 24px;
          position: relative;
          overflow: hidden;
          box-shadow: var(--shadow-card);
          transition: all 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
          cursor: pointer;
        }

        .dev-service-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 24px 42px rgba(163, 230, 53, 0.16), var(--shadow-card);
          border-color: var(--accent);
          background: linear-gradient(180deg, rgba(19, 26, 44, 0.98), rgba(19, 26, 44, 0.95));
        }

        .dev-service-icon {
          font-size: 3rem;
          margin-bottom: 16px;
          display: inline-block;
          transition: transform 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
        }

        .dev-service-card:hover .dev-service-icon {
          transform: scale(1.15) rotate(5deg);
        }

        .dev-service-card h3 {
          font-family: var(--heading-font);
          font-size: 1.35rem;
          color: #eef2f7;
          margin-bottom: 12px;
          line-height: 1.3;
        }

        .dev-service-card p {
          margin-bottom: 18px;
          font-size: 0.95rem;
        }

        .dev-service-features {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }

        .dev-feature-tag {
          font-size: 0.75rem;
          font-weight: 600;
          color: var(--accent-deep);
          background: rgba(163, 230, 53, 0.1);
          padding: 5px 12px;
          border-radius: 999px;
          border: 1px solid rgba(163, 230, 53, 0.2);
          transition: all 0.3s ease;
        }

        .dev-service-card:hover .dev-feature-tag {
          background: rgba(163, 230, 53, 0.15);
          border-color: var(--accent-deep);
        }

        /* PROCESS SECTION */
        .dev-process-grid {
          margin-top: 30px;
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 24px;
        }

        .dev-process-card {
          padding: 32px 24px;
          border-radius: 24px;
          background: linear-gradient(180deg, rgba(19, 26, 44, 0.96), rgba(19, 26, 44, 0.88));
          border: 1px solid rgba(163, 230, 53, 0.14);
          box-shadow: var(--shadow-card);
          transition: all 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
        }

        .dev-process-card:hover {
          transform: translateY(-6px);
          box-shadow: 0 20px 40px rgba(163, 230, 53, 0.12), var(--shadow-card);
          border-color: var(--accent);
        }

        .dev-process-phase {
          font-family: var(--heading-font);
          font-size: 1.35rem;
          color: #eef2f7;
          margin-bottom: 12px;
          line-height: 1.3;
        }

        .dev-process-desc {
          color: var(--text-soft);
          line-height: 1.8;
          margin-bottom: 16px;
          font-size: 0.95rem;
        }

        .dev-process-points {
          display: flex;
          flex-direction: column;
          gap: 10px;
        }

        .dev-process-point {
          display: flex;
          align-items: flex-start;
          gap: 10px;
          font-size: 0.9rem;
          color: var(--text-soft);
        }

        .dev-process-point::before {
          content: "✓";
          color: var(--accent-deep);
          font-weight: 800;
          flex-shrink: 0;
          margin-top: 2px;
        }

        /* TECHNOLOGY SECTION */

        .services-grid {
          margin-top: 24px;
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 22px;
        }

        .service-card {
          background:
            linear-gradient(180deg, rgba(19, 26, 44, 0.96), rgba(19, 26, 44, 0.88));
          border: 1px solid rgba(163, 230, 53, 0.14);
          border-radius: 26px;
          padding: 18px;
          position: relative;
          overflow: hidden;
          box-shadow: var(--shadow-card);
          transition: transform 0.28s ease, box-shadow 0.28s ease;
        }

        .service-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 24px 42px rgba(163, 230, 53, 0.12), var(--shadow-card);
        }

        .service-card::after {
          content: "";
          position: absolute;
          inset: auto -30% -60% auto;
          width: 160px;
          height: 160px;
          background: radial-gradient(circle, rgba(163, 230, 53, 0.14), transparent 70%);
          pointer-events: none;
        }

        .service-image {
          position: relative;
          border-radius: 20px;
          overflow: hidden;
          margin-bottom: 16px;
        }

        .service-image img {
          width: 100%;
          aspect-ratio: 4 / 4.5;
          object-fit: cover;
          display: block;
          transition: transform 0.45s ease, filter 0.45s ease;
        }

        .service-card:hover .service-image img {
          transform: scale(1.04);
          filter: brightness(1.04);
        }

        .service-card h3,
        .process-point h3,
        .footer-col h3 {
          font-family: var(--heading-font);
          color: #eef2f7;
          font-size: 1.2rem;
          margin-bottom: 10px;
        }

        .process-grid {
          margin-top: 24px;
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 22px;
        }

        .process-point {
          padding: 28px 24px;
          border-radius: 24px;
          background:
            linear-gradient(180deg, rgba(19, 26, 44, 0.96), rgba(19, 26, 44, 0.88));
          border: 1px solid rgba(163, 230, 53, 0.14);
          box-shadow: var(--shadow-card);
        }

        .process-number {
          width: 46px;
          height: 46px;
          border-radius: 50%;
          display: grid;
          place-items: center;
          font-weight: 800;
          color: white;
          margin-bottom: 16px;
          background: linear-gradient(135deg, var(--accent-deep), var(--accent-2));
          box-shadow: 0 10px 24px rgba(163, 230, 53, 0.22);
          transition: all 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
        }

        .process-point:hover .process-number {
          transform: scale(1.15);
          box-shadow: 0 0 30px rgba(163, 230, 53, 0.5);
        }

        .services-footer {
          margin-bottom: 34px;
        }

        .footer-container {
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
          gap: 60px;
          align-items: start;
          background:
            linear-gradient(180deg, rgba(19, 26, 44, 0.96), rgba(19, 26, 44, 0.88));
          border: 1px solid rgba(163, 230, 53, 0.14);
          border-radius: 28px;
          padding: 34px;
          box-shadow: var(--shadow-card);
        }

        .footer-col {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
        }

        .footer-col ul {
          list-style: none;
          padding: 0;
          margin: 0;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 10px;
        }

        .footer-col li {
          width: 100%;
          margin: 0;
        }

        .footer-col li a {
          display: inline-block;
          transition: color 0.25s ease, transform 0.25s ease;
        }

        .footer-col li a:hover {
          color: var(--accent-deep);
          transform: translateX(4px);
        }

        .social-links {
          display: flex;
          gap: 14px;
          margin-top: 16px;
          flex-wrap: wrap;
        }

        .social-links a {
          width: 42px;
          height: 42px;
          border-radius: 50%;
          display: grid;
          place-items: center;
          color: var(--accent-deep);
          background: rgba(163, 230, 53, 0.08);
          border: 1px solid rgba(163, 230, 53, 0.14);
          transition: transform 0.28s ease, background 0.28s ease, box-shadow 0.28s ease, color 0.28s ease;
        }

        .social-links a:hover {
          transform: translateY(-4px);
          color: #ffffff;
          background: linear-gradient(135deg, var(--accent-deep), var(--accent-2));
          box-shadow: 0 14px 28px rgba(163, 230, 53, 0.22);
        }

        .reveal-up,
        .reveal-left,
        .reveal-right,
        .title-glow {
          opacity: 0;
        }

        .reveal-up.visible {
          animation: fadeUp 0.9s ease forwards;
        }

        .reveal-left.visible {
          animation: fadeLeft 0.9s ease forwards;
        }

        .reveal-right.visible {
          animation: fadeRight 0.9s ease forwards;
        }

        .title-glow.visible {
          opacity: 1;
        }

        .center-text {
          text-align: center;
        }

        @media (max-width: 1100px) {
          .services-grid,
          .dev-services-grid {
            grid-template-columns: repeat(2, 1fr);
          }

          .process-grid,
          .dev-process-grid,
          .footer-container {
            grid-template-columns: 1fr;
          }
        }

        @media (max-width: 768px) {
          .nav-toggle {
            display: block;
          }

          .services-nav-links {
            position: absolute;
            top: 82px;
            right: 4%;
            width: 240px;
            display: none;
            flex-direction: column;
            align-items: flex-start;
            gap: 16px;
            padding: 20px;
            background: rgba(19, 26, 44, 0.98);
            border-radius: 18px;
            border: 1px solid rgba(163, 230, 53, 0.14);
            box-shadow: 0 18px 40px rgba(15, 23, 42, 0.12);
          }

          .services-nav-links.active {
            display: flex;
          }

          .services-hero {
            min-height: 450px;
          }

          .services-hero-content {
            padding: 70px 24px;
          }

          .hero-heading {
            font-size: 2.2rem;
          }

          .section-heading {
            font-size: 1.8rem;
          }

          .services-grid,
          .dev-services-grid,
          .process-grid,
          .dev-process-grid,
          .footer-container {
            grid-template-columns: 1fr;
          }

          .intro-shell {
            padding: 24px 22px;
          }

          .footer-container {
            padding: 26px;
            gap: 34px;
          }
        }

        @media (max-width: 480px) {
          .site-title {
            font-size: 1.15rem;
          }

          .services-nav-logo img {
            width: 46px;
            height: 46px;
          }

          .hero-btn {
            width: 100%;
            min-width: auto;
          }

          .section-mini {
            letter-spacing: 2px;
          }
        }

        /* ── UNIFIED SITE FOOTER (matches Tunga Drones page) ── */
        .tunga-footer {
          background: linear-gradient(180deg, rgba(163, 230, 53, 0.08), #070a12 18%);
          color: white;
          padding: 60px 5%;
          margin-top: 80px;
          border-top: 3px solid var(--accent);
        }

        .tunga-footer-content {
          width: min(1220px, 92%);
          margin: 0 auto;
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 50px;
          margin-bottom: 40px;
        }

        .tunga-footer-col h3 {
          font-family: var(--heading-font);
          font-size: 1.3rem;
          margin-bottom: 20px;
          color: var(--accent-2);
        }

        .tunga-footer-col p, .tunga-footer-col a {
          font-size: 0.95rem;
          line-height: 1.8;
          color: rgba(255,255,255,0.8);
          text-decoration: none;
        }

        .tunga-footer-col a:hover { color: var(--accent-2); }

        .tunga-social-links {
          display: flex;
          gap: 12px;
          margin-top: 20px;
        }

        .tunga-social-links a {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: rgba(163, 230, 53,0.2);
          display: grid;
          place-items: center;
          transition: all 0.3s ease;
          color: var(--accent-2);
        }

        .tunga-social-links a:hover {
          background: var(--accent);
          color: white;
          transform: translateY(-4px);
        }

      `}</style>

      <ThreeD />
      <div className="animated-bg">
        <div className="gradient-orb orb-1"></div>
        <div className="gradient-orb orb-2"></div>
        <div className="gradient-orb orb-3"></div>

        <div className="particles-layer" aria-hidden="true">
          {particles.map((particle) => (
            <span
              key={particle.id}
              className="particle"
              style={{
                width: particle.size,
                height: particle.size,
                left: particle.left,
                animationDelay: particle.delay,
                animationDuration: particle.duration,
                opacity: particle.opacity,
              }}
            />
          ))}
        </div>
      </div>

      <header className="services-navbar">
        <div className="services-nav-container">
          <div className="services-nav-logo">


            <img src={bslogo} alt="Bliss Sierra Logo" />
            <h1 className="site-title">Bliss Sierra</h1>
          </div>

          <div className="nav-toggle" onClick={() => setMenuOpen(!menuOpen)}>
            ☰
          </div>

          <nav className={`services-nav-links ${menuOpen ? "active" : ""}`}>
            <NavLink to="/" onClick={() => setMenuOpen(false)}>
              Home
            </NavLink>

            <NavLink to="/Tunga-Drones" onClick={() => setMenuOpen(false)}>
              Tunga Drones
            </NavLink>

            <NavLink to="/Our-Projects" onClick={() => setMenuOpen(false)}>
              Our Projects
            </NavLink>

            <NavLink to="/Services" onClick={() => setMenuOpen(false)}>
              Services
            </NavLink>

            <NavLink to="/Careers" onClick={() => setMenuOpen(false)}>
              Careers
            </NavLink>

            <NavLink to="/OurTeam" onClick={() => setMenuOpen(false)}>
              Our Core Team
            </NavLink>
          </nav>
        </div>
      </header>

      <section className="services-hero-section">
        <div className="services-hero">
          <div className="hero-overlay"></div>

          <div className="services-hero-content">
            <p className="section-mini hero-mini">CUSTOM DEVELOPMENT</p>

            <h2 className="hero-heading title-glow visible">
              Apps & Websites Built to Your Requirements
            </h2>

            <p className="hero-subtext">
              We develop custom mobile apps, web applications, and enterprise solutions tailored to your unique business needs. No templates, no compromises—just solutions that work.
            </p>

            <Link to="/Careers" className="hero-btn">
              Start Your Project
            </Link>
          </div>
        </div>
      </section>

      <section className="services-section">
        <div className="intro-shell">
          <div className="section-content reveal-up">
            <p className="section-mini">WHY CHOOSE US</p>

            <h2 className="section-heading title-glow">Custom Development Based on Your Vision</h2>

            <p>
              At Bliss Sierra, we don't believe in one-size-fits-all solutions. Every project is unique, and we listen carefully to understand your business requirements, goals, and constraints before we build anything.
            </p>

            <p>
              Whether you need a mobile app for iOS/Android, a scalable web platform, an e-commerce solution, or an enterprise system, we design and build exactly what you need—using modern technologies and best practices.
            </p>
          </div>
        </div>
      </section>

      {/* DEVELOPMENT SERVICES */}
      <section className="dev-services-section">
        <p className="section-mini">WHAT WE BUILD</p>
        <h2 className="section-heading title-glow">Types of Apps & Websites</h2>

        <div className="dev-services-grid">
          {developmentServices.map((service, index) => (
            <div className="dev-service-card reveal-up" key={index}>
              <div className="dev-service-icon">{service.icon}</div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              <div className="dev-service-features">
                {service.features.map((feature) => (
                  <span className="dev-feature-tag" key={feature}>{feature}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* DEVELOPMENT PROCESS */}
      <section className="process-section">
        <p className="section-mini center-text">OUR PROCESS</p>
        <h2 className="section-heading center-text title-glow">How We Build Your Solution</h2>

        <div className="dev-process-grid">
          {developmentProcess.map((process, index) => (
            <div className="dev-process-card reveal-up" key={index}>
              <h3 className="dev-process-phase">{process.phase}</h3>
              <p className="dev-process-desc">{process.description}</p>
              <div className="dev-process-points">
                {process.points.map((point) => (
                  <div className="dev-process-point" key={point}>{point}</div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      <footer className="tunga-footer">
        <div className="tunga-footer-content">
          <div className="tunga-footer-col reveal-left">
            <h3>Bliss Sierra</h3>
            <p>We are committed to delivering custom solutions that transform your business.</p>
          </div>
          <div className="tunga-footer-col reveal-up">
            <h3>Quick Links</h3>
            <NavLink to="/">Home</NavLink><br/>
            <NavLink to="/Tunga-Drones">Tunga Drones</NavLink><br/>
            <NavLink to="/Our-Projects">Our Projects</NavLink><br/>
            <NavLink to="/Services">Services</NavLink><br/>
            <NavLink to="/Careers">Careers</NavLink><br/>
            <NavLink to="/OurTeam">Our Core Team</NavLink>
          </div>
          <div className="tunga-footer-col reveal-right">
            <h3>Contact</h3>
            <p>📍 Neelakanta Nilayam, Kakateeya Hiils, Road No 9, Madhapur, Hyderabad-500081</p>
            <p>📧 contact@blisssierra.com</p>
            <p>📞 +91-7702232247</p>
            <div className="tunga-social-links">
              <a href="https://www.facebook.com/profile.php?id=61584931498008" target="_blank" rel="noreferrer" aria-label="Facebook"><FaFacebookF /></a>
              <a href="https://www.instagram.com/blisssierra1/" target="_blank" rel="noreferrer" aria-label="Instagram"><FaInstagram /></a>
              <a href="https://www.linkedin.com/feed/" target="_blank" rel="noreferrer" aria-label="LinkedIn"><FaLinkedin /></a>
              <a href="https://wa.me/917702232247" target="_blank" rel="noreferrer" aria-label="WhatsApp"><FaWhatsapp /></a>
            </div>
          </div>
        </div>
        <div style={{ borderTop: "1px solid rgba(255,255,255,0.1)", paddingTop: "30px", textAlign: "center", color: "rgba(255,255,255,0.6)" }}>
          <p>&copy; 2026 Bliss Sierra. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default Services;